<template>
  <media-content-wrapper
    hideSearchbar
    :cardBreakpoints="'xs6 sm3 md3 lg2'"
    :pageSize="'xs12'"
    :title="content.title"
    :description="content.description"
    :items="shownImages"
    :emptyListMessage="'Nenhuma imagem cadastrada...'"
  >
    <template v-slot:content="slotProps">
      <content-image :image="slotProps.item" @click="handleImageClick(slotProps.index)" />
    </template>

    <template v-slot:dialog>
      <ImageGalleryDialog
        :show="showImageGallery"
        :continuous="continuousCarousel"
        :currentIndex="imageGalleryIndex"
        :images="shownImages"
        @changedIndex="changedIndex"
        @closed="showImageGallery = false"
      />
    </template>
  </media-content-wrapper>
</template>

<script>
import MediaContentWrapper from '@/components/templates/MediaContentWrapper.vue';
import ImageGalleryDialog from './Dialog.vue';
import ContentImage from './ContentImage.vue';

export default {
  components: { ContentImage, ImageGalleryDialog, MediaContentWrapper },
  data: () => ({
    showImageGallery: false,
    imageGalleryIndex: 0,
    continuousCarousel: false,
  }),
  props: {
    content: Object,
  },
  computed: {
    shownImages() {
      // The title filter avoids the error of having untitled images, which causes
      // the application to crash at this time.
      const imagesCopy = this.content.images.slice().filter(image => image.title);
      imagesCopy.sort((a, b) => a.title.localeCompare(b.title));
      return imagesCopy;
    },
  },
  methods: {
    handleImageClick(index) {
      this.imageGalleryIndex = index;
      this.showImageGallery = true;
    },
    changedIndex(index) {
      this.imageGalleryIndex = index;
    },
  },
};
</script>
